// https://cmsdev.cruisecode.com/BookingPlatform/GetAllUniqueShipCompaniesByCompanyId?companyId=72aca93d-62a8-48e8-abf5-9814dc7604ae&_=1694584073742

export const GetAllUniqueShipCompaniesByCompanyId = [
    {
        ShipCompanyId: 1,
        ShipCompanyName: 'Carnival Cruise Lines',
        ShipCompanyAddress: null,
        ShipCounts: 0,
        IsActive: true,
        LastModifiedDate: null,
        LastModifiedBy: null,
        CreatedDate: '/Date(1611337489500)/',
        CreatedBy: null,
        CompanyUniqueID: '72aca93d-62a8-48e8-abf5-9814dc7604ae',
        ShipCompanyLogo:
            '/carnival-cruise-lines-operator_Carnival Cruise Lines.png',
        DataSource: 'WIDGETY-API',
        IsLive: false,
        IsLiveStr: 'NO',
    },
    {
        ShipCompanyId: 3,
        ShipCompanyName: 'Cunard Line',
        ShipCompanyAddress: null,
        ShipCounts: 0,
        IsActive: true,
        LastModifiedDate: null,
        LastModifiedBy: null,
        CreatedDate: '/Date(1611337489500)/',
        CreatedBy: null,
        CompanyUniqueID: '72aca93d-62a8-48e8-abf5-9814dc7604ae',
        ShipCompanyLogo: '/cunard-line_Cunard Line.png',
        DataSource: 'WIDGETY-API',
        IsLive: false,
        IsLiveStr: 'NO',
    },
    {
        ShipCompanyId: 4,
        ShipCompanyName: 'Holland America Line',
        ShipCompanyAddress: null,
        ShipCounts: 0,
        IsActive: true,
        LastModifiedDate: null,
        LastModifiedBy: null,
        CreatedDate: '/Date(1611337489500)/',
        CreatedBy: null,
        CompanyUniqueID: '72aca93d-62a8-48e8-abf5-9814dc7604ae',
        ShipCompanyLogo: '/holland-america-line_Holland America Line.png',
        DataSource: 'WIDGETY-API',
        IsLive: false,
        IsLiveStr: 'NO',
    },
    {
        ShipCompanyId: 5,
        ShipCompanyName: 'Norwegian Cruise Line',
        ShipCompanyAddress: null,
        ShipCounts: 0,
        IsActive: true,
        LastModifiedDate: null,
        LastModifiedBy: null,
        CreatedDate: '/Date(1611337489500)/',
        CreatedBy: null,
        CompanyUniqueID: '72aca93d-62a8-48e8-abf5-9814dc7604ae',
        ShipCompanyLogo: '/norwegian-cruise-line_Norwegian Cruise Line.png',
        DataSource: 'WIDGETY-API',
        IsLive: false,
        IsLiveStr: 'NO',
    },
    {
        ShipCompanyId: 6,
        ShipCompanyName: 'Oceania Cruises',
        ShipCompanyAddress: null,
        ShipCounts: 0,
        IsActive: true,
        LastModifiedDate: null,
        LastModifiedBy: null,
        CreatedDate: '/Date(1611337489500)/',
        CreatedBy: null,
        CompanyUniqueID: '72aca93d-62a8-48e8-abf5-9814dc7604ae',
        ShipCompanyLogo: '/oceania-cruises_Oceania Cruises.png',
        DataSource: 'WIDGETY-API',
        IsLive: false,
        IsLiveStr: 'NO',
    },
    {
        ShipCompanyId: 7,
        ShipCompanyName: 'Princess Cruises',
        ShipCompanyAddress: null,
        ShipCounts: 0,
        IsActive: true,
        LastModifiedDate: null,
        LastModifiedBy: null,
        CreatedDate: '/Date(1611337489500)/',
        CreatedBy: null,
        CompanyUniqueID: '72aca93d-62a8-48e8-abf5-9814dc7604ae',
        ShipCompanyLogo: '/princess-cruises_Princess Cruises.png',
        DataSource: 'WIDGETY-API',
        IsLive: false,
        IsLiveStr: 'NO',
    },
    {
        ShipCompanyId: 8,
        ShipCompanyName: 'Regent Seven Seas Cruises',
        ShipCompanyAddress: null,
        ShipCounts: 0,
        IsActive: true,
        LastModifiedDate: null,
        LastModifiedBy: null,
        CreatedDate: '/Date(1611337489500)/',
        CreatedBy: null,
        CompanyUniqueID: '72aca93d-62a8-48e8-abf5-9814dc7604ae',
        ShipCompanyLogo:
            '/regent-seven-seas-cruises_Regent Seven Seas Cruises.png',
        DataSource: 'WIDGETY-API',
        IsLive: false,
        IsLiveStr: 'NO',
    },
    {
        ShipCompanyId: 9,
        ShipCompanyName: 'Royal Caribbean International',
        ShipCompanyAddress: null,
        ShipCounts: 0,
        IsActive: true,
        LastModifiedDate: null,
        LastModifiedBy: null,
        CreatedDate: '/Date(1611337489500)/',
        CreatedBy: null,
        CompanyUniqueID: '72aca93d-62a8-48e8-abf5-9814dc7604ae',
        ShipCompanyLogo:
            '/royal-caribbean-international_Royal Caribbean International.png',
        DataSource: 'WIDGETY-API',
        IsLive: false,
        IsLiveStr: 'NO',
    },
    {
        ShipCompanyId: 10,
        ShipCompanyName: 'Seabourn',
        ShipCompanyAddress: null,
        ShipCounts: 0,
        IsActive: true,
        LastModifiedDate: null,
        LastModifiedBy: null,
        CreatedDate: '/Date(1611698009143)/',
        CreatedBy: null,
        CompanyUniqueID: '72aca93d-62a8-48e8-abf5-9814dc7604ae',
        ShipCompanyLogo: '/seabourn-cruise-line_Seabourn.png',
        DataSource: 'WIDGETY-API',
        IsLive: false,
        IsLiveStr: 'NO',
    },
    {
        ShipCompanyId: 11,
        ShipCompanyName: 'Celebrity Cruises',
        ShipCompanyAddress: null,
        ShipCounts: 0,
        IsActive: true,
        LastModifiedDate: null,
        LastModifiedBy: null,
        CreatedDate: '/Date(1648503558310)/',
        CreatedBy: null,
        CompanyUniqueID: '72aca93d-62a8-48e8-abf5-9814dc7604ae',
        ShipCompanyLogo: '/celebrity-cruises_Celebrity Cruises.png',
        DataSource: 'WIDGETY-API',
        IsLive: false,
        IsLiveStr: 'NO',
    },
    {
        ShipCompanyId: 12,
        ShipCompanyName: 'Silversea Cruises',
        ShipCompanyAddress: null,
        ShipCounts: 0,
        IsActive: true,
        LastModifiedDate: null,
        LastModifiedBy: null,
        CreatedDate: '/Date(1648503558310)/',
        CreatedBy: null,
        CompanyUniqueID: '72aca93d-62a8-48e8-abf5-9814dc7604ae',
        ShipCompanyLogo: '/silversea-cruises_Silversea Cruises.png',
        DataSource: 'WIDGETY-API',
        IsLive: false,
        IsLiveStr: 'NO',
    },
    {
        ShipCompanyId: 14,
        ShipCompanyName: 'Disney',
        ShipCompanyAddress: null,
        ShipCounts: 0,
        IsActive: true,
        LastModifiedDate: null,
        LastModifiedBy: null,
        CreatedDate: '/Date(1659564688710)/',
        CreatedBy: null,
        CompanyUniqueID: '72aca93d-62a8-48e8-abf5-9814dc7604ae',
        ShipCompanyLogo: null,
        DataSource: 'MANUAL',
        IsLive: false,
        IsLiveStr: 'NO',
    },
    {
        ShipCompanyId: 15,
        ShipCompanyName: 'Viking Cruises',
        ShipCompanyAddress: null,
        ShipCounts: 0,
        IsActive: true,
        LastModifiedDate: null,
        LastModifiedBy: null,
        CreatedDate: '/Date(1660164239407)/',
        CreatedBy: null,
        CompanyUniqueID: '72aca93d-62a8-48e8-abf5-9814dc7604ae',
        ShipCompanyLogo: null,
        DataSource: 'MANUAL',
        IsLive: false,
        IsLiveStr: 'NO',
    },
    {
        ShipCompanyId: 16,
        ShipCompanyName: 'testy cruises',
        ShipCompanyAddress: null,
        ShipCounts: 0,
        IsActive: true,
        LastModifiedDate: null,
        LastModifiedBy: null,
        CreatedDate: '/Date(1675292408853)/',
        CreatedBy: null,
        CompanyUniqueID: '72aca93d-62a8-48e8-abf5-9814dc7604ae',
        ShipCompanyLogo: null,
        DataSource: 'MANUAL',
        IsLive: false,
        IsLiveStr: 'NO',
    },
];
